import { useEffect } from 'react';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { setUnauthorizedHandler } from './api';
import { queryKeys } from './api/query-keys';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// Any 401 from the API wipes the cached user and lets the route guard kick
// the visitor back to /login. Routes themselves don't need to handle this.
setUnauthorizedHandler(() => {
  queryClient.setQueryData(queryKeys.auth.me, null);
});

export default function App() {
  // Re-sync data-theme/density on the html element on mount, in case the
  // store was hydrated after the initial paint.
  useEffect(() => {
    // No-op — the ui-prefs store sets this itself on import.
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
